module.exports = __webpack_public_path__ + "static/media/renew2.cfe40af6.png";